module.exports = __webpack_public_path__ + "static/media/img133_R.1c8187ce.jpg";